export default function LeafIconImpactPill() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_18122_73097"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          width="16"
          height="16"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_18122_73097)">
        <path
          d="M7.99935 13.3307C7.37713 13.3307 6.79102 13.2335 6.24102 13.0391C5.69102 12.8446 5.18824 12.5696 4.73268 12.2141L3.79935 13.1307C3.67713 13.253 3.52157 13.3141 3.33268 13.3141C3.14379 13.3141 2.98824 13.253 2.86602 13.1307C2.74379 13.0085 2.68268 12.853 2.68268 12.6641C2.68268 12.4752 2.74379 12.3196 2.86602 12.1974L3.78268 11.2807C3.42713 10.8252 3.15213 10.3196 2.95768 9.76406C2.76324 9.20851 2.66602 8.61962 2.66602 7.9974C2.66602 6.50851 3.18268 5.2474 4.21602 4.21406C5.24935 3.18073 6.51046 2.66406 7.99935 2.66406H13.3327V7.9974C13.3327 9.48628 12.816 10.7474 11.7827 11.7807C10.7493 12.8141 9.48824 13.3307 7.99935 13.3307ZM7.99935 11.9974C9.11046 11.9974 10.0549 11.6085 10.8327 10.8307C11.6105 10.053 11.9993 9.10851 11.9993 7.9974V3.9974H7.99935C6.88824 3.9974 5.94379 4.38628 5.16602 5.16406C4.38824 5.94184 3.99935 6.88628 3.99935 7.9974C3.99935 8.43073 4.06602 8.84462 4.19935 9.23906C4.33268 9.63351 4.51602 9.99184 4.74935 10.3141L8.19935 6.86406C8.32157 6.74184 8.47713 6.68073 8.66602 6.68073C8.8549 6.68073 9.01046 6.74184 9.13268 6.86406C9.26602 6.9974 9.33268 7.15573 9.33268 7.33906C9.33268 7.5224 9.26602 7.68073 9.13268 7.81406L5.68268 11.2641C6.0049 11.4974 6.36324 11.678 6.75768 11.8057C7.15213 11.9335 7.56602 11.9974 7.99935 11.9974Z"
          fill="#BFBFBF"
        />
      </g>
    </svg>
  );
}
